// src/components/LogoutButton/LogoutButton.tsx
import { Avatar, Dropdown, MenuProps } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store";
import { performLogout } from "../../auth/authActions";

const LogoutButton = () => {
  const dispatch = useDispatch<AppDispatch>();

  const handleLogout = () => {
    // Limpiar todo el localStorage
    localStorage.clear();
    
    dispatch(performLogout());
    
    window.location.href = "https://login.intranetsonrie.site/"; // o https://login.intranetsonrie.site en desarrollo
  };

  
  const items: MenuProps['items'] = [
   
    {
      key: "logout",
      label: "Cerrar sesión",
      icon: <LogoutOutlined />,
      onClick: handleLogout,
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
      <Avatar
        style={{ 
          cursor: "pointer", 
          backgroundColor: "#1890ff", 
          borderRadius: "7px",
          minWidth: '44px',
          minHeight: '44px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        icon={<UserOutlined />}
      />
    </Dropdown>
  );
};

export default LogoutButton;
